import request from '../request';
// 更新jwt
export const refreshJwt = (data) => {
  return request({
    url: (process.env.NODE_ENV == 'development' ? '/auth' : process.env.AUTH_ROOT) + '/v3/jwts',
    method: 'put',
    data
  })
}